module.exports = __webpack_public_path__ + "img/dac-default.381a0f16.jpg";